import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import axios from "axios";
import { BACKEND_URL } from "./constants";
 
axios.defaults.withCredentials = true;
axios.defaults.baseURL = BACKEND_URL;


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <App />

);


